export { init } from './init';

// For legacy support reasons, we re-export everything from the sentry package here
// A lot of packages do `import { Sentry } from "@snapchat/sentry-browser"` and we don't want to break them.
// NOTE: That 'init' isn't on this list.
// NOTE: This list has to be manual, ESM modules do not support `export * as Sentry from "@sentry/browser"`
export {
  SDK_VERSION,
  SEMANTIC_ATTRIBUTE_SENTRY_OP,
  SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN,
  SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE,
  SEMANTIC_ATTRIBUTE_SENTRY_SOURCE,
  Scope,
  addBreadcrumb,
  addEventProcessor,
  addIntegration,
  addTracingExtensions,
  captureConsoleIntegration,
  captureEvent,
  captureException,
  captureFeedback,
  captureMessage,
  captureSession,
  close,
  continueTrace,
  createTransport,
  debugIntegration,
  dedupeIntegration,
  endSession,
  extraErrorDataIntegration,
  flush,
  functionToStringIntegration,
  getActiveSpan,
  getClient,
  getCurrentHub,
  getCurrentScope,
  getGlobalScope,
  getIsolationScope,
  getRootSpan,
  getSpanDescendants,
  getSpanStatusFromHttpCode,
  inboundFiltersIntegration,
  isInitialized,
  lastEventId,
  makeMultiplexedTransport,
  moduleMetadataIntegration,
  parameterize,
  registerSpanErrorInstrumentation,
  rewriteFramesIntegration,
  sessionTimingIntegration,
  setContext,
  setCurrentClient,
  setExtra,
  setExtras,
  setHttpStatus,
  setMeasurement,
  setTag,
  setTags,
  setUser,
  spanToBaggageHeader,
  spanToJSON,
  spanToTraceHeader,
  startInactiveSpan,
  startNewTrace,
  startSession,
  startSpan,
  startSpanManual,
  suppressTracing,
  thirdPartyErrorFilterIntegration,
  updateSpanName,
  withActiveSpan,
  withIsolationScope,
  withScope,
  zodErrorsIntegration,
  WINDOW,
  BrowserClient,
  makeFetchTransport,
  chromeStackLineParser,
  defaultStackLineParsers,
  defaultStackParser,
  geckoStackLineParser,
  opera10StackLineParser,
  opera11StackLineParser,
  winjsStackLineParser,
  eventFromException,
  eventFromMessage,
  exceptionFromError,
  createUserFeedbackEnvelope,
  captureUserFeedback,
  forceLoad,
  getDefaultIntegrations,
  onLoad,
  showReportDialog,
  breadcrumbsIntegration,
  globalHandlersIntegration,
  httpContextIntegration,
  linkedErrorsIntegration,
  browserApiErrorsIntegration,
  lazyLoadIntegration,
  reportingObserverIntegration,
  httpClientIntegration,
  contextLinesIntegration,
  getReplay,
  replayIntegration,
  replayCanvasIntegration,
  feedbackAsyncIntegration,
  feedbackIntegration,
  feedbackSyncIntegration,
  getFeedback,
  sendFeedback,
  metrics,
  defaultRequestInstrumentationOptions,
  instrumentOutgoingRequests,
  browserTracingIntegration,
  startBrowserTracingNavigationSpan,
  startBrowserTracingPageLoadSpan,
  makeBrowserOfflineTransport,
  browserProfilingIntegration,
  spotlightBrowserIntegration,
  browserSessionIntegration,
  featureFlagsIntegration,
  buildLaunchDarklyFlagUsedHandler,
  launchDarklyIntegration,
  OpenFeatureIntegrationHook,
  openFeatureIntegration,
  unleashIntegration,
} from '@sentry/browser';
